import React from "react";

const PricePage = () => {
  return (
    <div className="services-container">
      <h2 className="title">СТОИМОСТЬ УСЛУГ ООО «МедГуру»</h2>

      <div className="table-wrapper">
        <table className="services-table">
          <thead>
            <tr>
              <th>№</th>
              <th>Наименование услуги</th>
              <th>Стоимость, руб, с НДС</th>
            </tr>
          </thead>
          <tbody>
            {/* 1 */}
            <tr>
              <td data-label="№">1</td>
              <td data-label="Наименование услуги">
                Услуги по разработке и сопровождению программ для ЭВМ
              </td>
              <td className="empty-price"></td>
            </tr>

            <tr>
              <td data-label="№">1.1.</td>
              <td data-label="Наименование услуги">Разработчик</td>
              <td data-label="Стоимость, руб, с НДС">от 3 000,00</td>
            </tr>

            <tr>
              <td data-label="№">1.2.</td>
              <td data-label="Наименование услуги">Менеджер</td>
              <td data-label="Стоимость, руб, с НДС">от 2 200,00</td>
            </tr>

            <tr>
              <td data-label="№">1.3.</td>
              <td data-label="Наименование услуги">Тестировщик</td>
              <td data-label="Стоимость, руб, с НДС">от 1 750,00</td>
            </tr>

            {/* 2 */}
            <tr>
              <td data-label="№">2</td>
              <td data-label="Наименование услуги">
                Предоставление прав использования программ для ЭВМ
              </td>
              <td className="empty-price"></td>
            </tr>

            <tr>
              <td data-label="№">2.1.</td>
              <td data-label="Наименование услуги">
                Простая (неисключительная) лицензия на использование программ
                для ЭВМ «Веб-версия CRM-системы Oragen», «Мобильное приложение
                Oragen»
              </td>
              <td data-label="Стоимость, руб, с НДС">от 3 000,00</td>
            </tr>

            {/* 3 */}
            <tr>
              <td data-label="№">3</td>
              <td data-label="Наименование услуги">
                Оказание услуг по организации и техническому сопровождению
                образовательного и (или) просветительского мероприятия —
                предоставление доступа к электронной образовательной информации
                с использованием собственной программы для ЭВМ —
                Образовательной медицинской платформы Medtouch 2.0
              </td>
              <td data-label="Стоимость, руб, с НДС">от 198 013,00</td>
            </tr>

            {/* 4 */}
            <tr>
              <td data-label="№">4</td>
              <td data-label="Наименование услуги">
                Оказание услуг по организации и проведению омниканального
                проекта для медицинских и/или фармацевтических работников о
                продукте с использованием собственной программы для ЭВМ —
                Образовательной медицинской платформы Medtouch 2.0
              </td>
              <td data-label="Стоимость, руб, с НДС">от 2 000 000,00</td>
            </tr>
          </tbody>
        </table>
      </div>

      <style jsx>{`
        .services-container {
          padding: 24px;
        }

        .title {
          text-align: center;
          margin-bottom: 20px;
        }

        .table-wrapper {
          width: 100%;
          overflow-x: auto;
        }

        .services-table {
          width: 100%;
          border-collapse: collapse;
        }

        .services-table th,
        .services-table td {
          border: 1px solid #ddd;
          padding: 10px;
          text-align: left;
          vertical-align: top;
        }

        .services-table th {
          background-color: #273661;
          font-weight: 600;
        }

        /* скрываем пустую цену */
        .empty-price {
          border-left: none;
          border-right: none;
        }

        /* 📱 Мобильная версия */
        @media (max-width: 768px) {
          .services-table thead {
            display: none;
          }

          .services-table,
          .services-table tbody,
          .services-table tr,
          .services-table td {
            display: block;
            width: 100%;
          }

          .services-table tr {
            margin-bottom: 16px;
            border: 1px solid #ddd;
            padding: 12px;
            border-radius: 8px;
            background: #273661;
          }

          .services-table td {
            border: none;
            padding: 6px 0;
            position: relative;
            padding-left: 50%;
          }

          .services-table td::before {
            content: attr(data-label);
            position: absolute;
            left: 0;
            top: 6px;
            width: 45%;
            font-weight: 600;
          }

          /* если цена пустая — полностью скрываем ячейку */
          .empty-price {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default PricePage;